
export const popupCalendlyWidget = (url) => {
  //@ts-ignore
  window.Calendly.initPopupWidget({
    url: `${url}?primary_color=3d7c54`
  })
}